/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { CardFooter } from '../../AIGeneralBlockCard';
import { UndoButton } from '../UndoButton';
import { useAIAgentMessage } from '../../AIAgentMessage/context';
function footerActionVariant(variant) {
    if (variant === 'primary' || variant === 'danger')
        return variant;
    return 'default';
}
/**
 * BlockWrapper Component
 *
 * Wraps block renderers and conditionally renders an UndoButton below the block
 * when `undoData` is present. This avoids modifying every individual block renderer.
 *
 * @example
 * ```tsx
 * <BlockWrapper block={block}>
 *   <MarkdownRenderer block={block} />
 * </BlockWrapper>
 * ```
 *
 * @version 1.0.0
 * @since 2026-03-04
 */
export function BlockWrapper({ block, children }) {
    var _a;
    const { onAction, onUndo } = useAIAgentMessage();
    const footerActions = onAction
        ? ((_a = block.footerActions) !== null && _a !== void 0 ? _a : []).map((action) => ({
            id: action.id,
            label: action.label,
            icon: action.icon,
            variant: footerActionVariant(action.variant),
            disabled: action.disabled,
            onClick: () => { var _a; return onAction(action.action, (_a = action.params) !== null && _a !== void 0 ? _a : {}, action.label); }
        }))
        : [];
    return (React.createElement(React.Fragment, null,
        children,
        footerActions.length > 0 && React.createElement(CardFooter, { groups: [{ actions: footerActions }] }),
        block.undoData && onUndo && React.createElement(UndoButton, { undoData: block.undoData, onUndo: onUndo })));
}
